import { useState } from "react";
import { WorkspaceDocuments } from "apps/project-iq/components/WorkspaceDocuments/WorkspaceDocuments";
import { WorkspaceInfoBanner } from "apps/project-iq/components/WorkspaceInfoBanner/WorkspaceInfoBanner";
import { useWorkspaceFilesStyles } from "./WorkspaceFiles.styles";
import { IWorkspaceFilesProps } from "./WorkspaceFiles.types";

export type { IWorkspaceFilesProps };

export const WorkspaceFiles = ({
  workspaceId,
  clientName,
  sharepointConnections,
  onSaveStatusChange,
}: IWorkspaceFilesProps): JSX.Element => {
  const styles = useWorkspaceFilesStyles();
  const [isDocumentsLoading, setIsDocumentsLoading] = useState(true);

  return (
    <div className={styles.contextFilesLayout}>
      <div className={styles.contextFilesContent}>
        <WorkspaceDocuments
          workspaceId={workspaceId}
          clientName={clientName}
          sharepointConnections={sharepointConnections}
          onSaveStatusChange={onSaveStatusChange}
          onLoadingChange={setIsDocumentsLoading}
        />
        {!isDocumentsLoading && (
          <WorkspaceInfoBanner>
            All team members have access to all files stored in this workspace
            for the engagement. All files are available as context throughout
            Project IQ.
          </WorkspaceInfoBanner>
        )}
      </div>
    </div>
  );
};
